import { useState } from 'react'
import styled from 'styled-components'
import { VideoData } from '../../../interfaces'
import { getTimeRemaining } from '../../../utils/time'
import useInterval from '../../../utils/useInterval'
import CardMuteToggle from './CardMuteToggle'
import LockDisplay from './LockDisplay'

type CardOverlayProps = {
  video: VideoData
  scheduledTime: Date
  onClick: () => void
}

/*======================== React component ===================================*/

const CardOverlay = ({ video, onClick, scheduledTime }: CardOverlayProps): JSX.Element => {
  const [live, setIsLive] = useState(scheduledTime <= new Date())

  useInterval(() => {
    const time = getTimeRemaining(scheduledTime)
    if (time.days <= 0 && time.hours <= 0 && time.minutes <= 0 && time.seconds <= 0) {
      setIsLive(true)
    } else {
      setIsLive(false)
    }
  }, 1000)

  return (
    <Wrapper>
      <CardMuteToggle />
      {(video.gated || !live) && (
        <LeftBottomCornerPositioned>
          <LockDisplay />
        </LeftBottomCornerPositioned>
      )}
      <LinkArea onClick={onClick} />
    </Wrapper>
  )
}

export default CardOverlay

/*======================== Styled components =================================*/

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  transition: opacity 300ms ease-out;
`

const LeftBottomCornerPositioned = styled.div`
  position: absolute;
  bottom: 15px;
  left: 15px;

  @media (min-width: 43em) {
    bottom: 25px;
    left: 25px;
  }
`

const LinkArea = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;
`
